import React from 'react'

const PartySection = ({ title, children }) => {
  return (
     <div className="rounded-lg border border-slate-200 p-4">
      <h4 className="mb-3 text-[13px] font-semibold text-slate-700">{title}</h4>
      <div className="space-y-3">{children}</div>
    </div>
  )
}

export default PartySection